import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {
    airlinesFilterShowAll,
    airlinesFilterShowMore,
    clearFilter,
    selectCarrierFilter
} from "../../actions/FlightsActions";
import PriceFormatter from "../../helpers/PriceFormatter";
import {onCarrierLogoError} from "../../helpers/CarrierLogoFallback";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import BaseFilterComponent from "./BaseFilterComponent";
import {UncontrolledTooltip} from "reactstrap";

const PAGE_SIZE = 10;

class AirlinesFilterBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'carriers';
        this.name = 'Air company';
        this.urlEnabled = props.urlFilters.carriers && props.urlFilters.carriers.length > 0;
    }

    toggleFilter(event) {
        this.props.selectCarrierFilter(event.target.value);
    }

    isChecked(key) {
        return this.props.airlines.selected.indexOf(key) !== -1;
    }

    isDisabled(isOnlyCarrier) {
        return isOnlyCarrier ? {disabled: 'disabled'} : null;
    }

    renderOneLine(carrierKey, carrierData, isOnlyCarrier) {
        let carrierSelector = `carrier-${carrierData.name.replace(/[^a-zA-Z0-9]/g, '-')}`;
        return (
            <div key={carrierKey} className="form-check">
                <label className="form-check-label">
                    <input className="form-check-input" type="checkbox" value={carrierKey}
                           onChange={this.toggleFilter.bind(this)}
                           checked={isOnlyCarrier ? true : this.isChecked(carrierKey)}
                           {...this.isDisabled(isOnlyCarrier)}
                    />
                    <img className="filter-airline-logo"
                         src={`/assets/cdn/flights/carriers/xsmall/${carrierKey}.png`}
                         alt={carrierData.name}
                         onError={onCarrierLogoError}
                    />
                    <small className="filter-airline-name">
                        <span id={carrierSelector}>{carrierData.name}</span>
                    </small>
                    <UncontrolledTooltip
                        delay={0}
                        fade={false}
                        placement="top"
                        target={carrierSelector}
                    >
                        {carrierData.name}
                    </UncontrolledTooltip>
                </label>
                <span className="tag badge badge-warning float-right"
                      {...this.priceFormatter.format(carrierData.price, true)}
                ></span>
            </div>
        );
    }

    renderList(carriers) {
        if (Object.keys(carriers).length === 0) {
            return null;
        }

        const isOnlyCarrier = Object.keys(carriers).length === 1;

        let filters = [];
        let carriersArray = Object.keys(carriers);
        if (!this.props.airlines.showAll) {
            carriersArray = carriersArray.slice(0, this.props.airlines.page * PAGE_SIZE);
        }
        carriersArray.map((key) => filters.push(this.renderOneLine(key, carriers[key], isOnlyCarrier)));

        return <div>{filters}</div>;
    }

    doRenderShowMore() {
        return !this.props.airlines.showAll && Object.keys(this.props.airlines.carriers).length > this.props.airlines.page * PAGE_SIZE;
    }

    showAll() {
        this.props.airlinesFilterShowAll();
    }

    renderShowMore() {
        if (!this.doRenderShowMore()) {
            return null;
        }

        return (
            <button className="btn btn-link show-more-link" onClick={this.showMore.bind(this)}>
                <small>{this.translator.trans('Show more')}...</small>
            </button>
        );
    }

    showMore() {
        this.props.airlinesFilterShowMore();
    }

    sortCarriers(carriers) {
        const unordered = carriers;
        Object.keys(carriers)
            .sort((a, b) =>
                carriers[a].price - carriers[b].price
            )
            .forEach(
                (key) => {
                    var value = unordered[key];
                    delete unordered[key];
                    unordered[key] = value;
                }
            );

        return unordered;
    }

    render() {
        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);

        let carriers = this.sortCarriers(this.props.carriers);

        return (
            <div>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="clearfix mb-2">
                        <span className="font-weight-bold">{this.translator.trans(this.name)}</span>
                        {this.renderClearFilterButton()}
                    </div>
                    {this.renderList(carriers)}
                    {this.renderShowMore()}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectCarrierFilter,
        airlinesFilterShowMore,
        airlinesFilterShowAll,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        airlines: state.AirlinesFilterReducer,
        translator: state.TranslationsReducer.translations,
        carriers: ownProps.carriers,
        socket: state.SocketReducer.socket,
        parameters: state.ParametersReducer.parameters,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AirlinesFilterBlock);



// WEBPACK FOOTER //
// ./src/components/filters/AirlinesFilterBlock.js